export default "__VITE_ASSET__SkRx1YCp__"